import {Room} from '@daedalus/core/src/room/types/room'
import {Offer} from '@daedalus/core/src/offer/types/offer'
import {lensProp, map, over} from 'ramda'
import {decorateOfferWithPayAtProperty} from 'business/offer'

export const deepUpdateRoomsOffer = (
  rooms: Room[],
  updateFn: (offer: Offer) => Offer
): Room[] => {
  const offers = lensProp<Room>('offers')
  return map(over(offers, map(updateFn)), rooms)
}

export const decorateRoomsOffers = (rooms: Room[]): Room[] => {
  return deepUpdateRoomsOffer(rooms, offer =>
    decorateOfferWithPayAtProperty(offer)
  )
}
